<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="fetching_order_store"
      :items="order_store_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ order_store_list.indexOf(props.item)+1 }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.order_base_code }}</td>
        <td>{{ props.item.order_time_start }}</td>
        <td>{{ props.item.order_note }}</td>
        <td
          class="text-xs-right"
        >{{ (parseFloat(props.item.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
      </template>
      <template slot="footer">
        <td colspan="5" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td
          class="text-xs-right"
        >{{(parseFloat(order_store_summary.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
      </template>
    </v-data-table>
    <div class="main-title mt-4 mb-3">SUMMARY</div>
    <v-card style="border-radius:10px;">
      <v-card-text>
        <v-layout justify-center>
          <v-flex xs5>
            <div>
              <span class="title-store">{{ showName }}</span>
              <div
                style="color:#898989;"
              >{{$route.params.datetime_start}} - {{$route.params.datetime_end}}</div>
              <v-divider class="mb-3" />
            </div>
            <table width="100%">
              <tr>
                <td class="text-table">Total sales</td>
                <td
                  class="text-xs-right"
                >{{order_store_summary.summary ? (parseFloat(order_store_summary.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
              </tr>
              <tr>
                <td
                  class="text-table"
                >Deduct Package {{order_store_summary.deduction && order_store_summary.summary ? order_store_summary.deduction*(100/order_store_summary.summary) : '-'}}%</td>
                <td
                  class="text-xs-right"
                >{{order_store_summary.deduction ? (parseFloat(order_store_summary.deduction).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :'0.00' }}</td>
              </tr>
              <tr>
                <td class="text-table">Paid store</td>
                <td
                  class="text-xs-right"
                  style="text-decoration:underline;"
                >{{ order_store_summary.amount_paid ? (parseFloat(order_store_summary.amount_paid).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      fetching_order_store: false,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Order code", value: "id", sortable: false },
        { text: "Order ref.", value: "id", sortable: false },
        {
          text: "Date Time order",
          value: "date_time",
          sortable: false
        },
        { text: "Remark", value: "remark", sortable: false, align: "center" },
        { text: "Sales", value: "sales", sortable: false, align: "center" }
      ],
      column_items: [{ text: "Sales", value: "summary", sortable: false }],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false
    };
  },
  watch: {
    order_store_list() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
      }
    }
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.order_store_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };
      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit(
        "fetchStorePaymentReport/getExportFormOrderStore"
      );
      this.$store.commit("fetchStorePaymentReport/getExportOrderStoreSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  },
  computed: {
    ...mapState({
      store_payment_list: state =>
        state.fetchStorePaymentReport.store_payment_list,
      order_store_list: state => state.fetchStorePaymentReport.order_store_list,
      order_store_summary: state =>
        state.fetchStorePaymentReport.order_store_summary,
      export_form_order_store: state =>
        state.fetchStorePaymentReport.export_form_order_store
    }),
    showName() {
      let name = "";
      for (let val of this.store_payment_list) {
        if (val.store_id == this.$route.params.storeid) {
          name = val.store_name;
          break;
        }
      }
      return name;
    }
  },
  async created() {
    if (
      this.$route.params.storeid &&
      this.$route.params.ordertype &&
      this.$route.params.order_status &&
      this.$route.params.datetime_start &&
      this.$route.params.datetime_end
    ) {
      this.fetching_order_store = true;
      await this.$store.dispatch(
        "fetchStorePaymentReport/getOrderStoreReport",
        {
          search_store_id: this.$route.params.storeid,
          order_type: this.$route.params.ordertype,
          order_status: this.$route.params.order_status,
          datetime_start: this.$route.params.datetime_start,
          datetime_end: this.$route.params.datetime_end
        }
      );
      this.fetching_order_store = false;
    }
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
}
</style>

